module.exports = __webpack_public_path__ + "static/controle-1-4ca6ec6eb942e74ecb3a890138fe4f44.jpg";